<template>
  <div id="contact" class="site-container">
    <h1>Let's Connect</h1>

    <img class="loading" src="/img/loader-1.svg" alt="Loading..." v-if="!iframe.loaded">

    <iframe :src="iframe.src" height="580" allowTransparency="true"
            ref="frame" @load="iframeLoad" v-show="iframe.loaded"></iframe>
  </div>
</template>
<script>
// @ is an alias to /src

export default {
  name: 'contact',
  components: {},
  data() {
    return {
      iframe: {
        src: 'https://j3ca.wufoo.com/embed/q9ea8bd0i9wq3k/',
        loaded: false
      }
    }
  },
  methods: {
    iframeLoad: function () {
      this.iframe.loaded = true;
    }
  },
  mounted() {
    window.scrollTo(0, 0);
  }
}
</script>